import React from "react";
import isMobile from "ismobilejs";
import { connect } from "react-redux";
import { guardarDatosAsistido, guardarDatosInconvenientes } from "./service.act";
import { callService, formatPhone, formatDate, formatRamo, goTo } from "../tools";
import CompletarForm from "./completar.frm.js";
import ComplementarWebMovil from "./complementarWebMovil.frm";
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';
import { servicios } from "../properties";

const validacion = "Error";
const origenRegistro = "POR_CL";
const mensajeItim = "Ocurrió un error inesperado, comunícate a la línea GNP 55 5227 9000 para más información.";
const msjDisculpe = "Disculpe, por el momento no es posible completar su registro," +
					" si requieres asistencia comunícate a Línea GNP al 55 5227 9000 opción 7.";
let contador = 0;

const mapState = (state) => {
	let poliza = state.registro.poliza;
	let vigencia = state.registro.inicioVigenciaPolizaDate;

	if (state.registro.configuracion.poliza_padre) {
		poliza = state.registro.configuracion.poliza_valida;
		vigencia = state.registro.configuracion.fchVigInicial;
	} else if (state.registro.configuracion.referencia) {
		poliza = state.registro.configuracion.referencia;
	}

	if (state.registro.configuracion.sistema == "INFO") {
		while (poliza.length < 14) {
			poliza = "0" + poliza;
		}
	}

	return {
		"loading": state.global.loading,
		"conectaMovil": state.global.conectaMovil,
		"ramo": state.registro.ramo,
		"poliza": poliza,
		"certificado": state.registro.certificado,
		"vigencia": vigencia,
		"email": state.registro.email,
		"nacimientoFecha": state.registro.fechaNacimiento,
		"lada_fijo": state.registro.ladaFijo,
		"lada_movil": state.registro.ladaCelular,
		"telefono_fijo": state.registro.telFijo,
		"telefono_movil": state.registro.telCelular,
		"dispositivo": state.global.dispositivo,
		"avisoAceptado": state.registro.avisoAceptado,
		"mediosElectronicos": state.registro.mediosElectronicos,
		sistema: state.registro.configuracion.sistema
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		},
		alerta: (sCode) => {
			dispatch({ "type": "MODAL_ALERT_CODE_SHOW", "codigo": sCode });
		},
		siguientePasoRegistro: () => {
			dispatch({ "type": "REGISTRO_PASO_SIGUIENTE" });
		},
		siguientePasoAsistido: () => {
			dispatch({ "type": "REGISTRO_ASISTIDO_SIGUIENTE_PASO" });
		},
		registrarDatos(sPaterno, sMaterno, sNombres) {
			dispatch(guardarDatosAsistido(sPaterno, sMaterno, sNombres));
		},
		registrarDatosInconvenientes(sTipo, sExtension, sLada, sTelefono) {
			dispatch(guardarDatosInconvenientes(sTipo, sExtension, sLada, sTelefono));
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		},
		pasoCompleto: () => {
			dispatch({ "type": "REGISTRO_COMPLETO", completo: true });
		}
	};
};

const getFechaVigencia = (fecha) => {
	if (fecha !== "") {
		const dia = fecha.substr(8, 9);
		const mes = fecha.substr(5, 2);
		const anio = fecha.substr(0, 4);
		return anio + mes + dia;
	} else {
		return false;
	}
}

class Completar extends React.Component {

	state = {
		showTooltip: false,
		mensaje: "",
		type: "",
		titulo: ""
	}

	getHerramienta = () => {
		return (isMobile.any == true) ? "APP" : "PORTAL";
	}

	submit = (data) => {
		contador = contador+1;
		if(contador<=1) {
			localStorage.removeItem('urlSeguridad');
			let herramienta = this.getHerramienta();
			this.props.loader(true);
			this.props.registrarDatos(data.apaterno, data.amaterno, data.nombres);
	
			new callService({
				service: "registro.datosAsistidos",
				secure: true,
				data: {
					ramo: formatRamo(this.props.ramo),
					poliza: this.props.poliza,
					certificado: this.props.certificado,
					vigencia: formatDate(this.props.vigencia),
					email: this.props.email,
					nacimientoFecha: getFechaVigencia(this.props.nacimientoFecha),
					ladaFijo: formatPhone(this.props.lada_fijo),
					ladaMovil: formatPhone(this.props.lada_movil),
					telefonoFijo: this.props.telefono_fijo,
					telefonoMovil: this.props.telefono_movil.substr(2),
					apaterno: data.apaterno,
					amaterno: data.amaterno,
					nombres: data.nombres,
					herramienta: herramienta,
					avisoAceptado: true,
					mediosElectronicos: true,
					origenapp: origenRegistro,
				}
			}).execute().then((respuesta) => {
				this.respuestaExitosa(respuesta);
				contador = 0;
			}).catch((error) => {
				contador = 0;
				console.log(error);
				this.props.loader(false);
				this.props.tagManager({
					"type": "EVENT_REGISTRO_SIG_INCORRECTOS_ASISTIDO", "dispositivo": this.props.dispositivo, "ramo": localStorage.getItem("ramo")
				});
				this.errorRespuesta(error);
				this.submit2();
			});
		}else{
			console.log('registro doble');
		}
	}

	respuestaExitosa = (respuesta) => {
		const herramienta = this.getHerramienta();
		localStorage.setItem("urlSeguridad", respuesta.url);
		localStorage.setItem('cveClienteUnico', respuesta.registrarClienteResponse.cveClienteUnico);
		this.props.tagManager({
			"type": "EVENT_REGISTRO_SIG_CORRECTOS_ASISTIDO", "dispositivo": this.props.dispositivo, "ramo": localStorage.getItem("ramo")
		});

		if (respuesta.registrarClienteResponse.banExito) {
			if (this.props.conectaMovil === true) {
				goTo(respuesta.urlCM);
			} else if (herramienta === "PORTAL") {
				this.registroBorradoUsuarios(respuesta);
				this.registroInconclusoPoliza(respuesta);
				this.registroInconcluso(respuesta);
				localStorage.setItem("registroAsistido", true);
				this.regresar();
			}
		}
	}

	registroBorradoUsuarios = (respuesta) => {
		console.log("respuesta", respuesta);

		new callService({
			service: "registro.datosBorradoUsuarios",
			secure: true,
			data: {
				ramaClave: respuesta.registrarClienteResponse.cveClienteUnico,
				completo: false,
				confidencialidad: false,
				contrato: false,
				email: this.props.email
			}
		}).execute().then((resp) => {
			console.log("Respuesta datosBorradoUsuarios ", resp);

		}).catch((error) => {
			console.log("Error datosBorradoUsuarios ", error);
		});
	}

	registroInconclusoPoliza = (respuesta) => {
		const bandera = false;
		const urlNormal = respuesta.url.substr(2);
		const urlPartida = urlNormal.substr(24);
		const arrayUrl = urlPartida.split("\/");
		const hashOne = arrayUrl[0];
		
		new callService({
			service: "registro.incConluirRegistroPoliza",
			secure: true,
			data: {
				poliza: this.props.poliza,
				certificado: this.props.certificado,
				sistema: localStorage.getItem('sistema'),
				banConcluirReg: bandera,
				path: hashOne
			}
		}).execute().then((respuesta) => {
			console.log("Respuesta incConluirRegistroPoliza ", respuesta);
		}).catch((error) => {
			console.log("Error incConluirRegistroPoliza ", error);
		});
	}

	registroInconcluso = (respuesta) => {
		const bandera = false;
		const urlNormal = respuesta.url.substr(2);
		const urlPartida = urlNormal.substr(24);
		const arrayUrl = urlPartida.split("\/");
		const hashOne = arrayUrl[0];
		
		new callService({
			service: "registro.incConcluirRegistro",
			secure: true,
			data: {
				correo: (this.props.email).toLowerCase(),
				banConcluirReg: bandera,
				path: hashOne
			}
		}).execute().then((respuesta) => {
			console.log("Respuesta incConcluirRegistro", respuesta);

		}).catch((error) => {
			console.log("Error incConcluirRegistro", error);
		});
	}

	errorRespuesta = (error) => {
		if (error.message.codigoError.includes("ITIM")) {
			this.muestraTooltip(true, 'error', validacion, mensajeItim);
		} else if (error.message.codigoError === "REG010" || error.message.codigoError === "REG005" || error.message.mensaje.includes("MS o informatica")) {
			this.muestraTooltip(true, 'error', validacion, msjDisculpe);
		} else if (error.message.codigoError === "ecl00100") {
			this.muestraTooltip(true, 'error', validacion, msjDisculpe);
		} else if (error.message.mensaje === "Failed to fetch") {
			this.muestraTooltip(true, 'error', validacion, "Ocurrio un error inesperado, favor de contactar a Soporte.");
		} else {
			this.muestraTooltip(true, 'error', validacion, error.message.mensaje);
		}
	}

	submit2 = (data) => {
		this.props.loader(true);
		this.muestraTooltip(true, 'error', validacion, msjDisculpe);
		localStorage.removeItem('urlSeguridad');
		this.props.registrarDatos(data.apaterno, data.amaterno, data.nombres);
		const $this = this;
		const extension = formatPhone(this.props.lada_movil);
		const tipo = "celular";
		const llamar = "";

		$this.props.registrarDatosInconvenientes(tipo, extension, formatPhone(this.props.lada_movil), this.props.telefono_movil.substr(2));

		const llamaServicio = new callService({
			service: "registro.datosInconvenientes",
			secure: true,
			data: {
				email: this.props.email,
				tipoTelefono: tipo,
				extension: extension,
				lada: formatPhone(this.props.lada_movil),
				telefono: this.props.telefono_movil.substr(2),
				llamar: llamar,
				sistema: this.props.sistema
			}
		});

		return llamaServicio.execute().then((respuesta) => {
			console.log("respuesta datosInconvenientes", respuesta);
			this.props.loader(false);
			this.props.pasoCompleto();
		}).catch((error) => {
			console.log("error datosInconvenientes", error);
			$this.props.loader(false);
		});
	}

	regresar = () => {
		this.props.tagManager({ "type": "EVENT_REGISTRO_REGRESAR_ASISTIDO", "dispositivo": this.props.dispositivo });
		goTo("gnp/registro");
	}

	muestraTooltip = (show, type?, titulo?, mensaje?) => {
		setTimeout(() => {
			this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
		}, 300);
	}

	cierraTooltip = e => {
		this.setState({
			showTooltip: !this.state.showTooltip
		});
		goTo("gnp/registro-reingenieria");
	}

	render() {
		return (
			<div>
				<ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
					show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
				</ModalSintillo>

				{this.props.dispositivo === "web" ?
					<CompletarForm onSubmit={this.submit2} /> :
					<ComplementarWebMovil onSubmit={this.submit2} />
				}
			</div>
		)
	}
}

export default connect(mapState, mapDispatch)(Completar);



// WEBPACK FOOTER //
// ./src/gnp-registro-asistido/completar.cmpt.js